import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "f-ui-filter" }
const _hoisted_2 = { class: "filter" }

import CommonButton from "@/components/common/CommonButton.vue";
import {Plus} from "utruckin-icons";

interface IFilter {
  store: any
}


export default /*@__PURE__*/_defineComponent({
  __name: 'filter',
  props: {
    store: {}
  },
  emits: ["clickedAdd"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit

const clicked = () => {
  emit('clickedAdd')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(CommonButton, {
        prepend: "",
        "prepend-icon": _unref(Plus),
        type: "primary",
        label: "Add Account",
        onClick: clicked
      }, null, 8, ["prepend-icon"])
    ])
  ]))
}
}

})